export default __webpack_public_path__ + "img/primary_4.png";